import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledPath = styled.path`
  ${({ pfill, theme }) =>
    `fill: ${typeof pfill === 'function' ? pfill(theme) : pfill}`}
`;

const IconUser = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <StyledPath
        d="M311.177 602.353c-69.205 0-135.654 27.538-184.588 76.471-48.936 48.934-76.353 115.387-76.353 184.588v100.353c0 33.267 26.968 60.235 60.235 60.235v0c33.267 0 60.235-26.968 60.235-60.235v0-100.353c0-37.294 14.805-73.040 41.176-99.412 26.374-26.374 61.995-41.176 99.294-41.176h401.647c37.294 0 72.922 14.805 99.294 41.176s41.176 62.118 41.176 99.412v100.353c0 33.267 26.968 60.235 60.235 60.235v0c33.267 0 60.235-26.968 60.235-60.235v0-100.353c0-69.201-27.536-135.654-76.471-184.588s-115.269-76.471-184.471-76.471z"
        pfill={fill}
      />
      <StyledPath
        d="M512.001 0c-143.445 0-261.059 117.615-261.059 261.059s117.614 260.941 261.059 260.941c143.441 0 261.059-117.498 261.059-260.941s-117.618-261.059-261.059-261.059zM512.001 120.471c78.333 0 140.588 62.252 140.588 140.588s-62.255 140.471-140.588 140.471c-78.338 0-140.588-62.134-140.588-140.471s62.251-140.588 140.588-140.588z"
        pfill={fill}
      />
    </svg>
  );
};

IconUser.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

IconUser.defaultProps = {
  width: '34',
  height: '34',
  fill: 'white',
};

export default IconUser;
